<template>
  <div id="contenedor-main-ejecuccion-configuracion-firmas">
    <tool-bar
      v-on:nuevaFirma="registrarNuevaFirma">
    </tool-bar>
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <listado
            :listado="getFirmas">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarRegistrarNuevaFirma"
      scrollable
      persistent
      width="600">
      <v-card>
        <v-card-title>
          Registrar nueva firma
        </v-card-title>
        <v-card-text
          style="max-height: 300px;">
          <registrar-nueva
            modulo="ejecucion"
            ref="registrarNuevaFirma"
            v-on:cerrar="cerrarRegistrarNuevaFirma">
          </registrar-nueva>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            tipo="formCancelar"
            label="Cancelar"
            @click="mostrarRegistrarNuevaFirma = !mostrarRegistrarNuevaFirma">
          </custom-button>
          <custom-button
            tipo="formAceptar"
            label="Guardar"
            @click="$refs.registrarNuevaFirma.guardar()">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FIRMAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/firmas/firmasPorModulo.gql';
import ToolBar from './ToolBar.vue';
import CustomButton from '@/components/buttons/Button.vue';
import RegistrarNueva from '@/components/administracion/ejecucion/configuracion/firmas/Nueva.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'MainEjecuccionConfiguracionFirmas',
  components: {
    ToolBar,
    CustomButton,
    RegistrarNueva,
    Listado,
  },
  data() {
    return {
      mostrarRegistrarNuevaFirma: false,
    };
  },
  methods: {
    cerrarRegistrarNuevaFirma() {
      this.registrarNuevaFirma();
    },
    registrarNuevaFirma() {
      this.mostrarRegistrarNuevaFirma = !this.mostrarRegistrarNuevaFirma;
    },
  },
  apollo: {
    firmasPorModulo: {
      query: FIRMAS_POR_MODULO,
      variables() {
        return {
          modulo: 'ejecucion',
        };
      },
    },
  },
  computed: {
    getFirmas() {
      if (!this.firmasPorModulo) return [];
      return this.firmasPorModulo;
    },
  },
};
</script>

<style lang="scss">

</style>
